var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":_vm.$route.meta.title,"value":true,"width":500},on:{"close-modal":_vm.closeModal}},[_c('accounting-edit',{attrs:{"id-account":_vm.id,"subsidiary-id":_vm.subsidiaryId,"disableSaveButton":_vm.disableSaveButton},on:{"update-account":_vm.updateAccount}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e32ecc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/accounting-plans/page-accounting-edit.vue
// module id = 1338
// module chunks = 5